/* eslint-disable react/prop-types */
/* eslint-disable consistent-return */
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import { constants } from 'src/constants/constant';

import styles from './Button.module.scss';

export const Button = forwardRef(
	(
		{
			variant,
			children,
			style,
			className,
			simpleClassName,
			ignoreExistingClassNames = false,
			disabled,
			...props
		},
		ref
	) => {
		let modifierClassName;
		let newClassName;
		if (simpleClassName === constants.BUTTON_ATOMIC_COMPONENT.DELETE)
			modifierClassName = styles.deleteButton;
		else if (simpleClassName === constants.BUTTON_ATOMIC_COMPONENT.BULKDATA)
			modifierClassName = styles.uploadButton;
		else if (
			simpleClassName === constants.BUTTON_ATOMIC_COMPONENT.UPLOAD_IMAGE
		) {
			modifierClassName = styles.imgUploadButton;
		} else if (
			simpleClassName === constants.BUTTON_ATOMIC_COMPONENT.REGENERATE
		) {
			modifierClassName = styles.regenerateButton;
		} else if (variant === constants.BUTTON_ATOMIC_COMPONENT.PRIMARY)
			modifierClassName = styles.primaryButton;
		else if (variant === constants.BUTTON_ATOMIC_COMPONENT.SECONDARY)
			modifierClassName = styles.secondaryButton;
		else if (variant === constants.BUTTON_ATOMIC_COMPONENT.TERTIARY)
			modifierClassName = styles.tertiaryButton;
		else if (variant === constants.BUTTON_ATOMIC_COMPONENT.OKBUTTON)
			modifierClassName = styles.okButton;
		else if (variant === constants.BUTTON_ATOMIC_COMPONENT.FEEDBACKS)
			modifierClassName = styles.feedbackButton;
		else modifierClassName = styles.defaultButton;
		if (simpleClassName != null) {
			newClassName = simpleClassName;
		} else {
			newClassName = '';
		}

		return (
			<>
				<button
					className={`${styles.TableButton} ${modifierClassName} ${newClassName}`}
					ref={ref}
					onClick={(e) => {
						if (e?.detail > 1) return;
						return props.onClick(e);
					}}
					style={style}
					disabled={disabled}
				>
					{children}
				</button>
			</>
		);
	}
);

Button.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
	variant: PropTypes.oneOf([
		constants.BUTTON_ATOMIC_COMPONENT.PRIMARY,
		constants.BUTTON_ATOMIC_COMPONENT.SECONDARY,
		constants.BUTTON_ATOMIC_COMPONENT.TERTIARY,
		constants.BUTTON_ATOMIC_COMPONENT.OKBUTTON,
		constants.BUTTON_ATOMIC_COMPONENT.DELETE,
		constants.BUTTON_ATOMIC_COMPONENT.BULKDATA,
	]),
	ignoreExistingClassNames: PropTypes.bool,
	simpleClassName: PropTypes.string,
};
